import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css/bundle";
import "swiper/css";

import PopularCard from "../../../components/landing/Popular/card";
import CardShimmer from "../../../components/landing/Popular/card-shimmer";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const Index = () => {
  const movieState = useSelector((state) => state.movieState);
  let shimmer = [0, 1, 2];
  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-3 items-center lg:gap-24 py-12 px-4 lg:px-24 bg-slate-100">
        <div className="lg:col-span-1">
          <div className="mb-6">
            <p className="inline px-4 py-2 text-xs lg:text-base bg-indigo-500 rounded-full text-white">
              Feature Movie
            </p>
            <h1 className="text-3xl lg:text-5xl font-bold text-slate-700 leading-normal lg:leading-normal mb-2">
              Join Movie Room with People
            </h1>
            <p className="xl:w-[450px] text-base lg:text-lg font-normal !w-[350px] !md:w-full text-slate-500 leading-normal">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et.
            </p>
          </div>
          <div className="flex py-4">
            <Link
              to="/"
              className="flex items-center justify-center py-4 px-8 bg-sky-500 text-white rounded-xl transition-all duration-300 ease-in-out hover:bg-sky-600"
            >
              Learn More
            </Link>
          </div>
          <div className="flex py-4 space-x-10">
            <div>
              <h1 className="text-3xl lg:text-5xl font-bold text-slate-700 mb-2">
                200+
              </h1>
              <p className="text-lg text-slate-600">Movies</p>
            </div>
            <div>
              <h1 className="text-3xl lg:text-5xl font-bold text-slate-700 mb-2">
                4180+
              </h1>
              <p className="text-lg text-slate-600">Members</p>
            </div>
          </div>
        </div>
        <div className="col-span-2">
          <Swiper
            className="relative !pt-8 !pb-16 !overflow-auto !overflow-y-hidden"
            spaceBetween={24}
            slidesPerView={1}
            // centeredSlides={true}
            breakpoints={{
              // when window width is >= 320px
              320: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              // when window width is >= 480px
              480: {
                slidesPerView: 1,
                spaceBetween: 30,
              },
              // when window width is >= 640px
              640: {
                slidesPerView: 1,
                spaceBetween: 21,
              },
              // when window width is >= 768px
              768: {
                slidesPerView: 2,
                spaceBetween: 21,
              },
              // when window width is >= 1024px
              1024: {
                slidesPerView: 1,
                spaceBetween: 21,
              },
              // when window width is >= 1440px
              1440: {
                slidesPerView: 2,
                spaceBetween: 21,
              },
            }}
          >
            {movieState.loading
              ? shimmer.map((item, index) => (
                  <SwiperSlide key={index}>
                    <CardShimmer />
                  </SwiperSlide>
                ))
              : movieState.error
              ? shimmer.map((item, index) => (
                  <SwiperSlide key={index}>
                    <CardShimmer />
                  </SwiperSlide>
                ))
              : movieState.movie.data &&
                movieState.movie.data.map((movie) => (
                  <SwiperSlide key={movie.id}>
                    <PopularCard data={movie} />
                  </SwiperSlide>
                ))}
          </Swiper>
        </div>
      </div>
    </>
  );
};

export default Index;
